const DESKTOP_BASE_URL = 'http://127.0.0.1:17890';

const desktopFetch = async (path, options = {}) => {
  const response = await fetch(`${DESKTOP_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    const message = data?.error || `Desktop request failed (${response.status})`;
    throw new Error(message);
  }
  return data;
};

export const pingDesktopForMedia = async () => {
  try {
    const data = await desktopFetch('/api/ping', { method: 'GET' });
    return !!data?.ok;
  } catch {
    return false;
  }
};

/**
 * Solicita ao Eagle Desktop que abra um arquivo localmente com o aplicativo padrão do sistema.
 * Faz sync sob demanda se o arquivo ainda não estiver na pasta sync.
 *
 * @param {{ domain: 'order'|'product', entityId: string, mediaId: string, filename: string, workspaceId: string }} params
 * @returns {Promise<void>} resolve quando aberto, rejeita com Error descritivo
 */
export const openLocalMedia = async ({ domain, entityId, mediaId, filename, workspaceId }) => {
  await desktopFetch('/api/media/open-local', {
    method: 'POST',
    body: JSON.stringify({ domain, entity_id: entityId, media_id: mediaId, filename, workspace_id: workspaceId }),
  });
};
